import React, { useState } from "react";
import { Box, Flex } from "rebass";
import { Loading, downloadCSV } from "react-admin";
import { useQuery, useWindowSize } from "../../../components";
// import Container from "./Container";
import moment from "moment";
import { get, map, filter } from "lodash";
import jsonExport from "jsonexport/dist";
import { ExportCSVFile } from "./utils";
import { ListInvoiced, HeaderFilters } from "./invoiced_field";
import ChartContainer from "./ChartContainer";
import ChartContainerDealer from "./ChartContainerDealer";

const MainFields = (props) => {
  const { width } = useWindowSize();
  const { dataList, translate, dealerId, isDealer, paramDealerId } = props;
  const [list, setList] = useState(dataList);
  const [speedGrowth, setSpeedGrowth] = useState("");
  const [valueCountry, setValueCountry] = useState([]);
  const [valueDealer, setValueDealer] = useState([]);
  const [myfilter, setMyFilter] = useState({
    country: [],
    dealer: [],
    category: [],
    target_setting: [],
    speed_growth: "",
  });
  const [valueCategory, setValueCategory] = useState([]);
  const [valueTargetSetting, setValueTargetSetting] = useState([]);
  const onExportCsv = () => {
    if (list && list.length > 0) {
      const newList = map(list, function (o) {
        return {
          country: get(o, "country", ""),
          dealer: get(o, "dealer", ""),
          category: get(o, "category", ""),
          target_setting: get(o, "target_setting", ""),
          speed_growth: get(o, "speed_growth", ""),
          last_year: get(o, "last_year", 0),
          target: get(o, "target", 0),
          invoiced: get(o, "invoiced", 0),
          gap: get(o, "gap", 0),
          ratio: get(o, "ratio", 0),
        };
      });
      /**
       * target: NumberAmountValue(get(o, "target", 0)),
          invoiced: NumberAmountValue(get(o, "invoiced", 0)),
          gap: NumberAmountValue(get(o, "gap", 0)),
          ratio: NumberAmountValue(get(o, "ratio", 0)),
       */
      jsonExport(
        newList,
        {
          headers: [
            "country",
            "dealer",
            "category",
            "target_setting",
            "speed_growth",
            "last_year",
            "target",
            "invoiced",
            "gap",
            "ratio",
          ],
        },
        (err, csv) => {
          if (err) return console.error(err);
          downloadCSV(
            csv,
            `invoiced-${moment().format("DD-MMM-YYYY-HH:mm:ss")}`
          );
        }
      );
    }
  };

  return (
    <Flex width={[1]} flexDirection={"column"}>
      <HeaderFilters
        {...props}
        setList={setList}
        valueCategory={valueCategory}
        valueCountry={valueCountry}
        valueDealer={valueDealer}
        myfilter={myfilter}
        setValueCategory={setValueCategory}
        setValueCountry={setValueCountry}
        setValueDealer={setValueDealer}
        setMyFilter={setMyFilter}
        speedGrowth={speedGrowth}
        setSpeedGrowth={setSpeedGrowth}
        valueTargetSetting={valueTargetSetting}
        setValueTargetSetting={setValueTargetSetting}
      />
      <ExportCSVFile
        translate={translate}
        list={list}
        onExportCsv={onExportCsv}
      />
      <Flex width={[1]} flexDirection={"column"}>
        {list && <ListInvoiced list={list} dealerId={dealerId} />}
      </Flex>
      {!isDealer ? (
        <Box width={[1]} py={[3]}>
          <ChartContainer
            width={width}
            myfilter={myfilter}
            baseUrl={`/reports/invoiced/chart`}
            tabTitle={"Invoiced"}
          />
        </Box>
      ) : (
        <Box width={[1]} py={[3]}>
          <ChartContainerDealer
            width={width}
            myfilter={myfilter}
            baseUrl={`/reports/invoiced/chart${paramDealerId}`}
            tabTitle={"Invoiced"}
          />
        </Box>
      )}
    </Flex>
  );
};

export default (props) => {
  const { dealerId, country } = props;
  const paramDealerId = dealerId !== null ? `?dealer_id=${dealerId}` : "";

  const { loaded, data } = useQuery(`/reports/invoiced${paramDealerId}`);

  if (!loaded) {
    return (
      <Box width={[1]}>
        <Loading />
      </Box>
    );
  }
  const dataList =
    data && data.length > 0
      ? Array.from(
          new Set(
            data.map((p, index) => {
              return { ...p, id: index };
            })
          )
        )
      : [];
  let myDataList = dataList;
  if (country && country.id) {
    myDataList = filter(dataList, function (o) {
      return o.country === country.name;
    });
  }
  return (
    <Box width={[1]} py={[3]}>
      <MainFields
        dataList={myDataList}
        {...props}
        paramDealerId={paramDealerId}
      />
      {/* <Container baseUrl={`/reports/invoiced/chart`} width={width} /> */}
    </Box>
  );
};
